import React, { useState } from 'react';
import Thankyou from '../payments/components/thankyou';
import PageHeader from '../../common/page-header';
import Card from '../../common/card';

import ContributionType from '../../component/contribution-type';
import QuestionAire from '../../component/questionnaire';
import Options from '../../component/options';
import Header from '../../section/header/header';
import { questionnAireHeaderData } from '../../component/contribution-type';
import { optionsHeaderData } from '../../component/questionnaire';
import { enrollmentMethodHeaderData } from '../../section/pay-zakat/type-of-zakat';
import TypeOfZakat from '../../section/pay-zakat/type-of-zakat';
import QuickZakat from '../../component/quick-zakat';
import SelectedOptions from '../../component/selectedOptions';
import EnrollmentMethod from '../../component/enrollment-methos';
import { getAppFlow } from '../utils/app.utils';
import { APP_FLOW } from '../../common/constant';
import Enrollment from '../../component/enrollment';
import { quickZakatHeader } from '../../component/options';
import { fidyahHeader } from '../../component/options';
import { zakatCalculatorHeader } from '../../component/options';
import PaymentMethod from '../../component/payment-method';
import PopupHome from '../pop-up/pop-up-home';
import { useDispatch } from 'react-redux';

import * as userAction from '../../redux/actions/userAction';
import * as zakatCalc from '../../redux/actions/zakatCalcAction';
import * as zakat from '../../redux/actions/zakatActions';
import { PaymentMethodHeader } from '../../component/skip-enollment';
import { SkipEnrollmentHeader } from '../../component/enrollment-methos';
import { ManualEnrollmentHeader, CorporateEnrollmentHeader } from '../../component/enrollment-methos';
import { useSelector } from 'react-redux';
import { config } from '../../common/constant';
import { AI_MASK } from '../../common/images-s3';
import { fidyahActions } from '../../redux/reducers/fidyah-slice';


export const contributionHeader = {
    title: 'Select Contribution Type',
    subTitle: 'Next - Questionnaire',
    steps: 1
}

const Home = ({ setHomePage }) => {
    const appFlow = getAppFlow()
    const dispatch = useDispatch()
    const user = useSelector((state) => state.userReducer)

    const [headerDatadd, setHeaderData] = useState(user.userStepsData)
    const headerData = user.userStepsData
    const [initialOfZakat, setInitialOfZakat] = useState(false)
    const [openHomePopup, setOpenHomePopup] = useState(false)
    const donationOptionHeader = (headerData.steps === 5) ? (appFlow === APP_FLOW.ZAKAT) ? quickZakatHeader : fidyahHeader : zakatCalculatorHeader

    const isSearchByNric = user.isSearchByNric
    const isSingpass = user?.userData?.flow === config.FLOW.SINGPASS
    const isAnonymous = user?.userData?.flow === config.FLOW.ANONYMOUS

    const enrollmentOptionHeader = (isSearchByNric || isSingpass || isAnonymous) ? SkipEnrollmentHeader : user.isBusinessPayer ? CorporateEnrollmentHeader : ManualEnrollmentHeader


    const handleBack = () => {
        switch (headerData.steps) {
            case 2:
                setHeaderData(contributionHeader)
                dispatch(userAction.updateUserSteps(contributionHeader))
                break;
            case 3:
                setHeaderData(questionnAireHeaderData)
                dispatch(userAction.updateUserSteps(questionnAireHeaderData))
                break;
            case 4:
                setHeaderData(optionsHeaderData)
                dispatch(userAction.updateUserSteps(optionsHeaderData))
                break;
            case 5:
                setHeaderData(donationOptionHeader)
                dispatch(userAction.updateUserSteps(donationOptionHeader))
                break;
            case 6:
                setHeaderData(enrollmentMethodHeaderData)
                dispatch(userAction.updateUserSteps(enrollmentMethodHeaderData))
                break;
            case 7:
                setHeaderData(enrollmentOptionHeader)
                dispatch(userAction.updateUserSteps(enrollmentOptionHeader))
        }
    }

    const setIsInitial = (value) => {
        setInitialOfZakat(value)
    }

    const handleBackToHome = () => {
        if(headerData.steps === 8)
        {
            handleOkay()
        }
        else {
            setOpenHomePopup(true)
        }

    }

    const selectedOptionType = JSON.parse(localStorage.getItem('selectedOption'))
    const isZakatWithAi = (getAppFlow() === APP_FLOW.ZAKAT) && selectedOptionType && (selectedOptionType.id == 2) && headerData.steps == 4

    const handleOkay = () => {
        // will reset all state
        dispatch(zakatCalc.resetZakatCalcData());
        dispatch(zakat.resetZakatData());
        dispatch(userAction.resetUserData());
        dispatch(fidyahActions.reset());
        localStorage.removeItem('selectedOption')
        setHomePage(false)
        sessionStorage.clear()
    }


    const handleClose = () => {
        setOpenHomePopup(false)
    }

    return (
        <>
            <Header handleBack={handleBack} backBtn={(headerData.steps !== 1 && headerData.steps !== 8)} handleBackToHome={handleBackToHome} hideHeader={isZakatWithAi} />
            {
                headerData.steps === 8 ? <Thankyou /> :
                    <div className={`main-page ${isZakatWithAi ? "aichat-page" : ""}`} style={isZakatWithAi ? { backgroundImage: `url(${AI_MASK})` } : {}}>
                        <div className='container'>
                            <PageHeader steps={headerData.steps} title={headerData.title} subTitle={headerData.subTitle} hideHeader={isZakatWithAi} />
                            <div className='flow-block'>
                                {
                                    headerData.steps === 1 &&
                                    <ContributionType setHeaderData={setHeaderData} />
                                }
                                {
                                    headerData.steps === 2 &&

                                    <QuestionAire setHeaderData={setHeaderData} />
                                }
                                {
                                    headerData.steps === 3 &&

                                    <Options setHeaderData={setHeaderData} />
                                }

                                {
                                    headerData.steps === 4 &&

                                    <SelectedOptions setHeaderData={setHeaderData} />
                                }

                                {
                                    headerData.steps === 5 &&

                                    <EnrollmentMethod setHeaderData={setHeaderData} />
                                }

                                {
                                    headerData.steps === 6 &&
                                    <Enrollment setHeaderData={setHeaderData} />
                                }

                                {
                                    headerData.steps === 7 &&
                                    <PaymentMethod setHeaderData={setHeaderData} />
                                }

                            </div>
                        </div>
                    </div>
            }
            {
                openHomePopup &&
                <PopupHome handleOkay={handleOkay} handleClose={handleClose} />
            }
        </>
    );
};

export default Home;